const Privacidad = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 space-y-4">
      <h1 className="text-2xl font-black uppercase italic">Política de Privacidad</h1>

      <p>
        El responsable del tratamiento de los datos es Jordi San Andres Salvador.
      </p>

      <p>
        Los datos personales recogidos (nombre, email, dirección, datos de pedido) se utilizarán para la gestión de pedidos, envíos, facturación y atención al cliente.
      </p>

      <p>
        La base legal del tratamiento es la ejecución de un contrato de compraventa y el consentimiento del usuario.
      </p>

      <p>
        Los datos podrán ser comunicados a proveedores de servicios de pago (Stripe) y empresas de transporte, únicamente para la correcta prestación del servicio.
      </p>

      <p>
        El usuario puede ejercer sus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad enviando un email a pedidos@sanna-wear.com.
      </p>

      <p>
        Los datos se conservarán durante el tiempo necesario para cumplir con las obligaciones legales y fiscales.
      </p>
    </div>
  );
};

export default Privacidad;
